import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconElectrocardiogram: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"electrocardiogram, activity, notification, pulse, heartbeat, beat"} maskId="square-filled-radius-0-stroke-1-IconElectrocardiogram"><path d="M9.00327 1.4082L5.63962 11.4992H1V12.4992H6.36038L8.99673 4.59012L15.0032 22.8599L18.3635 12.4992H22.75V11.4992H17.6365L14.9968 19.6384L9.00327 1.4082Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconElectrocardiogram;
